import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'

import { UploadProgressOverlayComponent } from './upload-progress-overlay.component'

@NgModule({
  imports: [CommonModule, MatIconModule, TranslateModule],
  declarations: [UploadProgressOverlayComponent],
  exports: [UploadProgressOverlayComponent]
})
export class UploadProgressOverlayModule {}
